export const AUTH_TOKEN = "auth_token";
export const AUTH_USER_DATA = "auth_user_data";
export const BASE_FRONT_URL = "http://localhost:3000/";
